import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environment';
import { DeviceSIM } from '../models/device-sim.model';
import { normalizeApiArray } from '../utils/api-response.util';

@Injectable({
  providedIn: 'root'
})
export class DeviceSIMService {
  private apiUrl = `${environment.apiUrl}/DeviceSIM`;

  constructor(private http: HttpClient) { }

  getDeviceSIMs(): Observable<DeviceSIM[]> {
    return this.http.get<unknown>(this.apiUrl).pipe(
      map(response => normalizeApiArray<DeviceSIM>(response))
    );
  }

  getDeviceSIM(id: number): Observable<DeviceSIM> {
    return this.http.get<DeviceSIM>(`${this.apiUrl}/${id}`);
  }

  createDeviceSIM(sim: Partial<DeviceSIM>): Observable<DeviceSIM> {
    return this.http.post<DeviceSIM>(this.apiUrl, sim);
  }

  updateDeviceSIM(id: number, sim: Partial<DeviceSIM>): Observable<DeviceSIM> {
    return this.http.put<DeviceSIM>(`${this.apiUrl}/${id}`, sim);
  }

  deleteDeviceSIM(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  activateSIM(id: number): Observable<DeviceSIM> {
    return this.http.post<DeviceSIM>(`${this.apiUrl}/${id}/activate`, {});
  }

  deactivateSIM(id: number): Observable<DeviceSIM> {
    return this.http.post<DeviceSIM>(`${this.apiUrl}/${id}/deactivate`, {});
  }

  updateDataUsage(id: number, dataUsed: number): Observable<DeviceSIM> {
    return this.http.patch<DeviceSIM>(`${this.apiUrl}/${id}/usage`, { dataUsed });
  }

  rechargeSIM(id: number, amount: number, expiryDate: string): Observable<DeviceSIM> {
    return this.http.post<DeviceSIM>(`${this.apiUrl}/${id}/recharge`, {
      amount,
      expiryDate
    });
  }

  getExpiringSIMs(daysThreshold: number = 7): Observable<DeviceSIM[]> {
    return this.http.get<DeviceSIM[]>(`${this.apiUrl}/expiring/${daysThreshold}`);
  }

  getLowDataSIMs(threshold: number = 10): Observable<DeviceSIM[]> {
    return this.http.get<DeviceSIM[]>(`${this.apiUrl}/low-data/${threshold}`);
  }
}
